<template>

  <div class="container">
    <audio :src="audioUrl" loop preload ref="horn" style="position: fixed;z-index:-1;opacity:0" @play="handlePlay"
      @pause="handlePause"></audio>
    <div class="tool_main">
      <div class="overlay-center">
        <div class="overlay-center-pano">
          <img src="/static/main/VR.png" class="panoAudio1" @click="ctrVr()">
          <img src="/static/main/audio.png" v-show="isAudioadd" class="panoAudio" @click="ctrAudio()">
          <img :src="isfovadd ? '/static/main/cod1.png' : '/static/main/cod.png'"
            v-show="panoInfo.userId != '#/' || !panoInfo.userId" class="panoAudio2" @click="fovchange()">
          <!-- 视频播放器 -->
          <div class="overlay-view" v-if="videoLayerShow">
            <div class="overlay-but"><img src="/static/main/close.png" @click="closeVideoLayer" /></div>
            <video ref="video" :src="videoActive" controls="controls" class="overlay-video"></video>
          </div>
          <!--富文本内容弹窗-->
          <div class="edit_container" v-if="showEditorHtml" style="padding: 30px 0;">
            <div class="edit_close"><img src="/static/main/close.png" @click="editorHtmlShow(false)"></div>
            <div class="quill-main ql-editor" id="editorDiv" v-html="editorhtml"></div>
          </div>
          <div id="pano" v-show="isallReady">
          </div>
        </div>
        <!-- 场景导航 -->
        <NavList :sceneList="sceneList" :currentSceneId="currentSceneId" @goToScene="goToScene" @addPano="addPano"
          :sceneListNumData="sceneListNum" :isShow="true" />
      </div>
    </div>

    <div :class="errorMsg ? 'mssage act' : 'mssage'" v-show="errorMsg">{{ errorMsg }}</div>
  </div>
</template>
<script>
import NavList from "../../src/components/NavList.vue";
import Tools from "../../src/components/Tools.vue";
import AddHotspot from "../../src/components/AddHotspot.vue";
import { access_token } from '../../src/api/request.js'
import { tblMediaAssetsId, tblHotspotById, addTblHotspot, isFavorites, tblFavorites } from "../../src/api/api.js";

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  name: "KrpanoView",
  components: {
    NavList,
    Tools,
    AddHotspot,
  },
  data() {
    return {
      editorhtml: '',
      showEditorHtml: false,//是否显示富文本内容弹窗
      videoLayerShow: false,
      movingSpot: {},
      isfovadd: false,
      errorMsg: '',
      toolAct: 0,
      hlookat: '',
      vlookat: '',
      isVr: false,
      isAudioadd: false,
      isallReady: false,//全景是否加载完了
      isfirstViewReady: false, //第一视角是否加载完了
      activeToolName: '视角',
      activeNumber: 0,//是否操作过全景数据
      isSelectAudio: false,
      isShowHot: false,
      isAudio: false,
      isAudioPlay: false,
      audioUrl: '',
      canShowLeft: false,
      krpano: null,
      Minikrpano: null,
      videoUrl: '',
      // sceneList: [], // 场景集合
      panoInfo: {},//页面传过来 的信息
      currentSceneId: 0, // 当前场景的索引
      addHotTab: 0,
      trackMouseId: null,
      isAddHotspotShow: false,
      clickMouseLocation: {}, // 点击的位置
      moveIntervalId: null, // 移动定时器
      toAddHotSpot: {},//添加热点
      sceneList: [],//场景集合
      sceneApiList: [],//场景集合
      HotSpotList: [
        {
          ath: '-64.97776800745834',//水平位置
          atv: '8.562602208531933',//垂直位置
          distorted: false,
          edge: "center",//热点边缘
          id: 1734590087123,
          name: "peak_hotspot_1734590087123",//热点名称
          oy: "-20",//垂直偏移
          peak_sceneId: 0,//热点所属场景
          peak_to_scene: "scene_tour1",//热点跳转场景
          content: "\n\n\t\t<view hlookat=\"0\" vlookat=\"0\" fovtype=\"MFOV\" fov=\"120\" maxpixelzoom=\"2.0\" fovmin=\"70\" fovmax=\"140\" limitview=\"auto\"/>\n\n\t\t<preview url=\"static/vtour2/panos/tour.tiles/preview.jpg\"/>\n\n\t\t<image>\n\t\t\t<cube url=\"static/vtour2/panos/tour.tiles/pano_%s.jpg\"/>\n\n\t\t\t<cube url=\"static/vtour2/panos/tour.tiles/mobile/pano_%s.jpg\" devices=\"mobile\"/>\n\t\t</image>\n\t<style name=\"peak_hotspotstyle_animation_tooltip\" url=\"static/vtour2/skin/hotspot/portal.png\" scale=\"0.5\" edge=\"center\" oy=\"-20\" distorted=\"false\" normal=\"false\" onloaded=\"do_crop_animation(100,100,15);add_hotspot_tooltip();\"/>\n\t\t\n\n\t",//热点内容
          heading: "",//热点朝向
          index: 0,//热点索引
          lat: "",//纬度
          lng: "",//经度
          onstart: "",//热点开始
          thumburl: "static/vtour2/panos/tour.tiles/thumb.jpg",//缩略图
          thumbx: 75,//缩略图x轴
          thumby: "10",//缩略图y轴
          title: "tour",//热点标题
          // peak_to_name: 'scene_tour1',
          peak_to_sceneId: 1,// 热点跳转场景id
          peak_tooltip: "",//热点提示
          peak_type: "3",//热点类型
          scale: 0.5,//热点缩放
          style: "skin_hotspotstyle",//热点样式
          url: "static/skin/vtourskin_hotspot.png",//热点图片
        }
      ],
      videoList: [
      ],
      // tourUrl: 'static/',
      // tourUrl: 'https://qjlc.dawangdawang.cn/img/',
      tourUrl: '/img/',
      audioList: [],
      sceneListNum: [],
    };
  },
  props: {
    groupId: {
      require: true,
    },
    id: {
      require: true,
    },
    title: {
      require: true,
    },
  },
  // emits: [
  //   "goToScene", // 跳转视图
  // ],

  mounted() {
    if (this.$route.query.length > 0) {
      this.panoInfo = this.$route.query
      this.tourUrl = this.tourUrl + this.panoInfo.groupId//本地测试时，需要注释掉
      this.panoInfo.userId = this.panoInfo.userId.substring(0, this.panoInfo.userId.length - 2)
      this.getPanoInfo()//获取全景信息
      this.fov()//是否已收藏
    } else {
      let windowStr = window.location.href.lastIndexOf('?')
      let windowUrl = window.location.href.substring(windowStr + 1, window.location.href.length);
      let urlArr = windowUrl.split('&');
      let urlObj = {};
      for (let i = 0; i < urlArr.length; i++) {
        let urlItem = urlArr[i].split('=');
        if (urlItem[0] == 'title') {
          urlItem[1] = decodeURIComponent(urlItem[1])
        }
        urlObj[urlItem[0]] = urlItem[1];
      }
      this.panoInfo = urlObj
      this.tourUrl = this.tourUrl + this.panoInfo.groupId//本地测试时，需要注释掉
      this.panoInfo.userId = this.panoInfo.userId.substring(0, this.panoInfo.userId.length - 2)
      this.getPanoInfo()//获取全景信息
      this.fov()//是否已收藏
    }
    if (this.toolAct == 0) {
      this.activeToolName = '视角'
    } else if (this.toolAct == 1) {
      this.activeToolName = '热点'
    } else if (this.toolAct == 2) {
      this.activeToolName = '音乐'
    } else if (this.toolAct == 3) {
      this.activeToolName = '视频'
    }
  },

  methods: {
    //热点富文本内容弹窗显示隐藏
    editorHtmlShow(e){
      this.showEditorHtml=e
    },
    //新增收藏
    fovchange() {
      let data = {
        userId: this.panoInfo.userId,
        contentId: this.panoInfo.id
      }
      tblFavorites(data, this.panoInfo.access_token).then(res => {
        this.fov()
      }).catch(err => {
        // console.log(err)
      })
    },
    handlePlay() {
      console.log('播放')
      this.isAudioPlay = true
    },
    handlePause() {
      console.log('暂停')
      // this.isAudioPlay = false
    },
    // 音频控制
    ctrAudio() {
      if (!this.isAudioPlay) {
        this.isAudioPlay = true
        this.$refs.horn.play();//播放
      } else {
        this.isAudioPlay = false
        this.$refs.horn.pause();//暂停
      }
    },
    //陀螺仪功能
    ctrVr() {
      this.isVr = !this.isVr
      this.iosGrantedTips()
      if (this.isVr) {
        this.krpano.call("set(plugin[skin_gyro].sensor, 0);");//使用绝对/真实世界导向陀螺仪跟踪。
        // 定义哪个浏览器事件应该用于设备移动跟踪:
        // 0 - deviceorientation事件
        // 在这里，传感器融合将由浏览器自己完成。
        // 不幸的是，这个事件的数据在许多Android设备和Android浏览器中都有bug或者是坏的(慢的、不准确的、错误的)。
        // 1 - devicemotion事件(默认)
        // 在这里，传感器融合将由krpano完成。
        // 浏览器提供来自加速度和陀螺仪传感器的原始数据，krpano将它们结合起来以获得最终的设备旋转:
        // 陀螺仪的数据非常快速和准确，但陀螺仪传感器只能测量相对旋转，因此随着时间的推移，它会偏离真实的物理方向。
        // 为了补偿这种漂移，使用了加速度传感器。这个传感器测量地球的重力加速度，可以作为绝对参考。
        // 但是加速度数据非常嘈杂，它只能用于检测"倾斜"旋转(向左，向右，向上或向下倾斜)-围绕设备本身的旋转不能通过加速度检测，为此需要陀螺仪数据。
        // 因此，来自两个传感器的数据将被合并/融合。加速度数据将进行低通滤波，并用作慢速"稳定"和陀螺仪数据，以便在所有方向上快速准确地运动。

        //默认是1，但是需要设置成0才能防止陀螺仪的灵敏度过高以及抖动的问题
        //定义用于设备移动跟踪的浏览器事件：
        //0 - deviceorientation 事件**
        //这里传感器融合将由浏览器本身完成。
        //不幸的是，来自此事件的数据在许多 Android 设备和 Android 浏览器中存在错误或错误（缓慢、不准确、错误）。
        //1 - devicemotion事件（默认）**
        //此处传感器融合将由 krpano 完成。
        //浏览器提供来自加速度和陀螺仪传感器的原始数据，krpano 将它们组合起来以获得最终的设备旋转：
        //陀螺仪数据非常快速和准确，但陀螺仪传感器仅测量相对旋转，因此随着时间的推移它会偏离真实的物理方向。
        //为了补偿这种漂移，使用了加速度传感器。该传感器测量地球的重力加速度，可用作绝对参考。
        //但是加速度数据非常嘈杂，它只能用于检测"倾斜"旋转（向左、向右、向上或向下倾斜）——加速度无法检测到围绕设备本身的旋转，为此需要陀螺仪数据。
        //因此来自两个传感器的数据将被组合/融合。加速度数据将被低通滤波并用作慢速"稳定"和陀螺仪数据，以便在各个方向快速准确地移动。
        //使用 devicemotion 事件（设置传感器 = 1）是默认的，通常应该没有必要或好处使用 deviceorientation 事件，除非可能是一些极端的浏览器错误......
        //注 - 在 iOS 13.4/Safari 13.1 中，devicemotion 事件已损坏。因此，在这些系统上，传感器的默认值 设置为 0 以使用 deviceorientation 事件（正在工作）。
        this.krpano.call("set(plugin[skin_gyro].sensor_mode, 0);");// 传感器类型
        //0 =直接使用最新的可用的传感器数据。 没有内插或外推法。 根据sensor-time-intervals的浏览器 运动可以是不平稳的或平滑。
        //1 =最新之间顺利插入 可用的传感器数据。 这将给一个非常光滑但延迟运动。
        //2 =预测设备传感器数据之间的旋转,然后插入。
        //3 =推断最新可用的传感器数据 当前帧的时间。 这将给一个快速响应和平滑运动,但可以有抽搐 当外推/预测数据和实际运动不匹配。
        //4 =预测当前帧的旋转装置。 这将给一个快速响应和平滑运动,但可以有抽搐 当外推/预测数据和实际运动不匹配。
        //5 =预测设备旋转和推断 传感器数据从最新的事件当前帧时间。

        //这个参数也相对重要，除了0跟1之外，其余的都会有很强烈的抖动问题，0最平滑
        this.krpano.call("set(plugin[skin_gyro].url, 'static/plugins/gyro2.js');");//根据设备卷筒转动/调平观看相机。
        this.krpano.call("set(plugin[skin_gyro].camroll,false);");//根据设备卷筒转动/调平观看相机。
        // this.krpano.call("set(plugin[skin_gyro].friction, 0.99);");//陀螺仪运动的摩擦/振动抑制。
        this.krpano.call("set(plugin[skin_gyro].absolute, false);");//绝对定位
        this.krpano.call("set(plugin[skin_gyro].north, 0);");//陀螺仪运动的摩擦/振动抑制。
        this.krpano.call("set(plugin[skin_gyro].touch_mode,'full');");//根据设备卷筒转动/调平观看相机。
        // this.krpano.call("set(plugin[skin_gyro].softstart, 0.9);");//陀螺仪运动的摩擦/振动抑制。
        this.krpano.call("set(plugin[skin_gyro].autocalibration, false);");//绝对定位
        this.krpano.call("set(plugin[skin_gyro].desktopsupport, false);");//陀螺仪运动的摩擦/振动抑制。
        setTimeout(() => {
          this.krpano.call("set(plugin[skin_gyro].friction, 0.8);");
        }, 1000);
        this.krpano.call("set(plugin[skin_gyro].enabled,true);");//开启
      } else {
        this.krpano.call("set(plugin[skin_gyro].enabled,false);");//关闭
      }


    },
    iosGrantedTips() {
      // this.errorMsg="ios用户授权"
      // alert("用户未允许权限")
      //直接获取调用动作与方向的权限
      if (typeof DeviceMotionEvent.requestPermission === 'function') {
        alert("访问用户设备运动数据授权，若不授权，将无法使用陀螺仪功能。")
        DeviceMotionEvent.requestPermission().then((response) => {
          // alert("用户授权成功！")
          // this.changeMsg('用户授权成功！')
          if (response === 'granted') {
            // this.changeMsg('授权成功')
            // alert("加载krpano全景图相关代码")
            // this.errorMsg="加载krpano全景图相关代码"
          } else if (response === 'denied') {
            alert("您之前拒绝了访问设备运动数据的请求，无法使用陀螺仪功能，请在设置中打开权限。")
            // 用户拒绝了权限请求
            // console.log('用户拒绝了访问设备运动数据的请求');
          } else {
            // alert("用户未允许权限1")
          }
        });
      } else {
        // alert("用户未允许权限")
        // this.errorMsg="用户未允许权限"
        // this.isVr = !this.isVr
      }

    },
    //是否收藏
    fov() {
      let data = {
        userId: this.panoInfo.userId,
        contentId: this.panoInfo.id
      }
      isFavorites(data, this.panoInfo.access_token).then(res => {
        this.isfovadd = res.data
      }).catch(err => {
        // console.log(err)
      })
    },
    //场景中添加热点
    addhotspoti(hotspotInfo) {
      if (!this.krpano || !hotspotInfo?.name) return;

      const newHotSpotName = hotspotInfo.name;
      // 移除已存在的同名热点
      // if (this.krpano.get(`hotspot[${newHotSpotName}]`)) {
      //   this.krpano.call(`removehotspot(${newHotSpotName})`);
      // }

      this.krpano.call("addhotspot(" + newHotSpotName + ");");
      this.krpano.set("hotspot[" + newHotSpotName + "].url", hotspotInfo.url);
      this.krpano.set("hotspot[" + newHotSpotName + "].ath", hotspotInfo.ath);
      this.krpano.set("hotspot[" + newHotSpotName + "].atv", hotspotInfo.atv);
      this.krpano.set("hotspot[" + newHotSpotName + "].title", hotspotInfo.title);
      this.krpano.set("hotspot[" + newHotSpotName + "].linkedscene", hotspotInfo.linkedscene);
      this.krpano.set("hotspot[" + newHotSpotName + "].dive", hotspotInfo.dive);
      this.krpano.set("hotspot[" + newHotSpotName + "].edge", hotspotInfo.edge || 'center');
      this.krpano.set("hotspot[" + newHotSpotName + "].scale", hotspotInfo.scale || 1);//设置图片不能拖动
      this.krpano.set("hotspot[" + newHotSpotName + "].peak_type", hotspotInfo.peak_type);
      this.krpano.set("hotspot[" + newHotSpotName + "].peak_sceneId", hotspotInfo.peak_sceneId);
      this.krpano.set("hotspot[" + newHotSpotName + "].peak_to_scene", hotspotInfo.peak_to_scene);
      this.krpano.set("hotspot[" + newHotSpotName + "].peak_to_sceneId", hotspotInfo.peak_to_sceneId);
      // this.krpano.set("hotspot[" + newHotSpotName + "].draggable", 'false');//设置热点不能拖动



      // 处理动态热点（GIF）
      if (hotspotInfo.url && hotspotInfo.url.indexOf("gif") !== -1) {
        // 设置动态效果相关属性
        this.krpano.set("hotspot[" + newHotSpotName + "].peak_tooltip", hotspotInfo.url);
        // 使用更安全的动画设置
        this.krpano.set("hotspot[" + newHotSpotName + "].style", 'skin_hotspotstyle_animation_tooltip');
        this.krpano.set("hotspot[" + newHotSpotName + "].distorted", 'false');
        this.krpano.set("hotspot[" + newHotSpotName + "].zoom", 'true');
        this.krpano.set("hotspot[" + newHotSpotName + "].renderer", 'css3d');
        // 设置动画参数
        this.krpano.set("hotspot[" + newHotSpotName + "].frame", '0');
        this.krpano.set("hotspot[" + newHotSpotName + "].framewidth", '100');
        this.krpano.set("hotspot[" + newHotSpotName + "].frameheight", '100');
        this.krpano.set("hotspot[" + newHotSpotName + "].framerate", '15');
        //加载效果
        this.krpano.set("hotspot[" + newHotSpotName + "].onloaded", `if(loaded,
            copy(frame,0);
            delayedcall(0.0,if(loaded,set(frame,calc(frame + 1)); if(frame GE 15, set(frame,0));));
          );add_hotspot_tooltip_top()`);
      } else {
        //加载效果
        this.krpano.set("hotspot[" + newHotSpotName + "].onloaded", `add_hotspot_tooltip_top()`);
      }


      // 添加视频相关属性（如果是视频热点）
      if (hotspotInfo.peak_type === 1) {
        // 设置视频参数
        this.krpano.set("hotspot[" + newHotSpotName + "].videourl", hotspotInfo.videourl);
        this.krpano.set("hotspot[" + newHotSpotName + "].posterurl", hotspotInfo.posterurl);
        this.krpano.set("hotspot[" + newHotSpotName + "].loop", hotspotInfo.loop || true);
        this.krpano.set("hotspot[" + newHotSpotName + "].pausedonstart", hotspotInfo.pausedonstart || true);
        this.krpano.set("hotspot[" + newHotSpotName + "].distorted", hotspotInfo.distorted || false);
      } else if (hotspotInfo.peak_type == 5) {//文本弹窗
        if (hotspotInfo.editorhtml) {
          this.krpano.set("hotspot[" + newHotSpotName + "].editorhtml", hotspotInfo.editorhtml);
        }
        let that = this
        let clearHtml = setTimeout(() => {
          that.content = ''
          clearTimeout(clearHtml)
        }, 1000)
      }
      // 执行添加热点命令
      try {
        // 确保热点创建成功后再设置事件
        setTimeout(() => {
          const hotspot = this.krpano.get(`hotspot[${newHotSpotName}]`);
          if (hotspot) {
            this.hotSpotInitEvent(newHotSpotName, hotspotInfo);
          }
        }, 100);
      } catch (error) {
        console.error('Error adding hotspot:', error);
        this.changeMsg('添加热点失败，请重试');
      }
    },

    //富文本热点点击事件
    showEditor(hotspotInfo) {
      this.editorhtml = hotspotInfo.editorhtml
      this.showEditorHtml = true
    },
    /**
     * 预览
     */
    // preview() {
    //   window.open("static/vtour1/tour.html");
    // },
    //获取场景信息
    getPanoInfo() {

      // this.initPano()//初始化全景，测试用
      // return
      tblHotspotById(this.panoInfo.groupId, this.panoInfo.access_token).then(res => {
        if (res.data) {
          if (res.data.glMusic) {//如果有全局背景音乐，把全局背景音乐拿出来
            this.audioAllUrl = res.data.glMusic
          }
          this.sceneApiList = JSON.parse(res.data.content)
          this.sceneList = JSON.parse(res.data.content)
          console.log(this.sceneList, 'sceneList')
          this.getSceneHotspotNow(0)
          console.log(this.currentSceneId, 'currentSceneId')
          if (res.data.peakToScene&&res.data.peakToScene!='[]') {
            this.sceneListNum = JSON.parse(res.data.peakToScene)
            this.currentSceneId = this.sceneListNum[0];//获取当前是第几个场景
          }
        }
        this.initPano()//初始化全景
      }).catch(err => {
        // console.log(err)
      })
    },
    //加载初始场景
    initPano() {
      document.getElementById('pano').innerHTML = ''//防止进入时重复使用上一个场景
      // console.log(this.tourUrl + "/vtour/tour.xml")
      let time2 = setTimeout(() => {//加延时，怕场景信息还没处理完
        window.embedpano({
          // swf: this.tourUrl + "/vtour2/tour.swf", // 测试用，正式的需要注释掉
          // xml: this.tourUrl + "/vtour2/tour.xml",
          swf: this.tourUrl + "/vtour/tour.swf", // 有则表示加载 flash 引擎，如果设置 html5:only 则不需要该值
          xml: this.tourUrl + "/vtour/tour.xml?t=" + new Date().getTime(), // 启动时的配置文件，保证是最新的文件
          target: "pano", // 要渲染到的目标容器 ID
          html5: "auto", // 如果有需要用到 flash ，可设置为 auto
          //id: "krpanoSWFObject", // 默认的 krpano 对象，每一个 viewer 对应唯一 id ，与 JS 交互时要用到
          mobilescale: 1.0, // 移动设备缩放，1 表示不缩放，默认 0.5
          passQueryParameters: true, // 是否接受 URL 传参，例如：tour.html?html5=only&startscene=scene2
          onready: (krpano_interface) => {
            this.krpano = krpano_interface;
            // console.log('一')
            clearTimeout(time2)
            let that = this
            let readyPano = setTimeout(() => {//初始化不完全，后继操作拿不到数据，加延时
              that.initPanoInfo();
              clearTimeout(readyPano)
            }, 2000)
            //获取场景数据，总是拿不到， 加循环，直到拿到位置
            let readyScene = setInterval(() => {//初始化不完全，后继操作拿不到数据，加延时
              that.initSceneList()
              if (this.sceneList.length > 0) {
                clearInterval(readyScene)
                that.initSceneView()//处理场景数据
              }
            }, 1000)
          },
        });

        // window.myGetXML = this.transmitXML;
      }, 200)
    },
    //处理初始化数据
    initSceneList() {
      // 获取场景
      if (this.sceneList.length == 0) {//如果接口返回的场景列表中是空的，也就是生成以后还没有做任何处理过的场景
        this.sceneList = this.krpano.get("scene").getArray(); // 所有场景图
        this.sceneApiList = this.sceneList
      } else {//处理场景数组中标题，如果场景中remark和xml文件中的场景remark不相同时，需要显示xml文件中的，不显示热点接口中调的
        let tourScene = this.krpano.get("scene").getArray(); // 所有场景图
        //为防止场景数据不能及时拿到，加延时
        let tourSceneTime = setTimeout(() => {
          for (let n = 0; n < tourScene.length; n++) {
            if (this.sceneApiList[n].remark != tourScene[n].remark) {
              this.sceneApiList[n].remark = tourScene[n].remark
              this.sceneList[n].remark = tourScene[n].remark
            }
          }
          clearTimeout(tourSceneTime)
        }, 1500)
      }
    },
    //获取场景后，处理当前场景初始化视角等
    initSceneView() {

      if (this.sceneApiList) {
        //设置第一视角
        if (this.sceneApiList[this.currentSceneId]) {
          if (this.sceneApiList[this.currentSceneId].initH) {
            this.krpano.set("view.hlookat", this.sceneApiList[this.currentSceneId].initH);
            this.krpano.set("view.vlookat", this.sceneApiList[this.currentSceneId].initV)
          }
        }
      }
      //如果需要显示的第一个场景不是场景列表中的第一个场景时，场景加载完成以后，需要跳转到该场景中
      // if (this.currentSceneId && this.currentSceneId != 0) {
      if (!this.currentSceneId) {//如果第一场景id没有，就默认显示第一个场景，并且做跳转，用来处理热点显示问题
        this.currentSceneId = 0
      }
      let times3 = setTimeout(() => {
        this.goToScene({
          peak_to_scene: this.sceneList[this.currentSceneId].name,
          peak_to_sceneId: this.currentSceneId,
        });
        //第一视角和控制栏都设置好以后再显示
        this.isallReady = true
        clearTimeout(times3)
      }, 500)

    },
    //初始化所有场景中的信息
    initPanoInfo() {
      // 通过设置这些图层的visible属性为false，可以隐藏这些图层，从而实现界面上的一些效果，比如隐藏控制栏、底部分割线和滚动窗口等。 */
      //隐藏下面的控制栏
      this.krpano.set("layer[skin_control_bar].visible", false);
      this.krpano.set("layer[skin_splitter_bottom].visible", false);
      this.krpano.set("layer[skin_scroll_window].visible", false);
      let timeTo5 = 0
      let interval1 = setInterval(() => {//隐藏控制栏时，总是已经设置false了，但是还是显示，是krpano初始化时长的问题，无法规避
        // console.log(that.krpano.get("layer[skin_control_bar].visible"))
        this.krpano.set("layer[skin_control_bar].visible", false);
        this.krpano.set("layer[skin_splitter_bottom].visible", false);
        this.krpano.set("layer[skin_scroll_window].visible", false);
        if (timeTo5 > this.sceneList.length * 2) {
          clearInterval(interval1)
        }
      }, 1000)

    },
    //获取当前场景热点
    getSceneHotspotNow(e) {//这里改了
      //把当前场景的热点拿出来显示
      let HotSpotList = []//普通热点
      let videoList = []//视频
      if (this.sceneList[e]) {
        if (this.sceneList[e].hotSpots) {
          this.sceneList[e].hotSpots.forEach(hot => {
            if (hot.peak_type == 1) {//视频热点
              videoList.push(hot)
            } else {             //普通热点
              HotSpotList.push(hot)
            }
          })
        }
        // console.log(88888)
        // console.log(HotSpotList)
        this.HotSpotList = HotSpotList

        this.videoList = videoList
        //把当前场景的背景音乐拿出来显示
        if (this.sceneList[e].audioUrl) {
          this.isAudioPlay = false
          this.audioUrl = 'https://qjlc.dawangdawang.cn/' + this.sceneList[e].audioUrl
          this.isAudioadd = true
        } else {

          this.audioUrl = ''
          this.isAudioPlay = false
          this.isAudioadd = false
        }
        //把当前场景的背景音乐拿出来显示
        // console.log('回显')
        // console.log(this.sceneList[e])
        this.audioUrlAct = ''
        this.audioUrl = ''
        if (this.sceneList[e].audioUrl) {//如果有当前场景的背景音乐，就显示按钮，并且赋值
          this.audioUrl = this.sceneList[e].audioUrl
          this.audioUrlAct = this.sceneList[e].audioUrl
          this.isAudioadd = true
        } else if (this.audioAllUrl) {          //如果没有当前场景的背景音乐，但是有全局背景音乐，就显示按钮，并且赋值
          this.audioUrl = this.audioAllUrl
          this.isAudioadd = true
        } else {//如果既没有当前场景音乐，也没有全部背景音乐，就都不显示
          this.audioUrl = ''
          this.isAudioadd = false
        }
      }
    },
    //保存全景
    // save() {
    //   // 获取场景
    //   // this.sceneList = this.krpano.get("scene").getArray(); // 所有场景图
    //   // console.log(this.sceneList);
    //   let content = JSON.stringify(this.sceneList)
    //   let data = {
    //     name: this.panoInfo.title,//string 热点名称可选
    //     id: this.panoInfo.groupId,//string 必需场景图的id 必填场景图的id
    //     peakSceneId: this.panoInfo.groupId,//string 必需场景图的id 必填场景图的id
    //     peakToScene: '',//string 要跳转的场景图名可选
    //     peakToSceneId: '',//string 要跳转的场景图id可选
    //     peakTooltip: '',//string 设点提示标签内容可选
    //     content: content,//string 内容信息
    //   }
    //   let that = this
    //   // return
    //   addTblHotspot(data, this.panoInfo.access_token).then((res) => {
    //     console.log(res)
    //     this.changeMsg("保存成功")
    //   }).catch((err) => {

    //   })
    // },
    //信息提示
    changeMsg(e) {
      this.errorMsg = e
      let clears
      clears = setTimeout(() => {
        this.errorMsg = ''
        clearTimeout(clears)
      }, 3000)
    },
    //加载热点事件
    hotSpotInitEvent(spotName, hotspotInfo) {
      if (!this.krpano || !spotName) return;

      const hotspot = this.krpano.get(`hotspot[${spotName}]`);
      if (!hotspot) return;

      // 设置热点事件

      if (hotspotInfo.peak_type == 3) {
        let that=this
        this.krpano.get("hotspot[" + spotName + "]").onclick = function () {
          // console.log('点击了热点')
          // console.log(hotspotInfo)
          that.goToScene({
            peak_to_scene: hotspotInfo.peak_to_scene,
            peak_to_sceneId: hotspotInfo.peak_to_sceneId,
          });
        }
      }  else if (hotspotInfo.peak_type === 1) {
        // 视频热点
        hotspot.onclick = () => {
          this.showVideoLayer(hotspotInfo);
        };
      } else if (hotspotInfo.peak_type == 5) {//富文本类型，点击弹出富文本弹窗
        // this.krpano.get("hotspot[" + spotName + "]").onloaded = 'do_crop_animation(500,500, 60);'
        this.krpano.get("hotspot[" + spotName + "]").onclick = this.showEditor.bind(this, hotspotInfo)
      } else if (hotspotInfo.peak_type == 2)  {
        // 普通热点
        hotspot.onclick = 'looktohotspot(get(name),50);';
      }
    },

    //加载热点事件
    // hotSpotInitEvent(spotName, hotspotInfo) {
    //   if (!this.krpano || !spotName) return;
    //   let that = this
    //   //热点拖拽事件
    //   this.krpano.get("hotspot[" + spotName + "]").ondown = function (e) {
    //     // that.movingSpot = that.selectHotSpot();
    //     // var intervalId = setInterval(that.autoMove, 1000.0 / 30.0);
    //     // that.krpano.set("autoMoveIntervalId", intervalId);
    //     // that.canShowLeft = false;
    //   };
    //   this.krpano.get("hotspot[" + spotName + "]").onup = function () {
    //     window.clearInterval(that.krpano.get("autoMoveIntervalId"));
    //     that.movingSpot = {};
    //     that.canShowLeft = true;
    //   };
    //   if (hotspotInfo.peak_type == 3) {
    //     this.krpano.get("hotspot[" + spotName + "]").onclick = function () {
    //       // console.log('点击了热点')
    //       // console.log(hotspotInfo)
    //       that.goToScene({
    //         peak_to_scene: hotspotInfo.peak_to_scene,
    //         peak_to_sceneId: hotspotInfo.peak_to_sceneId,
    //       });
    //     }
    //   } else if (hotspotInfo.peak_type == 1) {//视频类型
    //     this.krpano.get("hotspot[" + spotName + "]").onclick = this.showVideoLayer.bind(this, hotspotInfo)
    //   } else if (hotspotInfo.peak_type == 2) {//图片类型
    //     this.krpano.get("hotspot[" + spotName + "]").onloaded = 'do_crop_animation(500,500, 60);'
    //     this.krpano.get("hotspot[" + spotName + "]").onclick = 'looktohotspot(get(name),50);'
    //   } else if (hotspotInfo.peak_type == 5) {//富文本类型，点击弹出富文本弹窗
    //     // this.krpano.get("hotspot[" + spotName + "]").onloaded = 'do_crop_animation(500,500, 60);'
    //     this.krpano.get("hotspot[" + spotName + "]").onclick = this.showEditor.bind(this, hotspotInfo)
    //   }
    //   // if (this.hotspotInfo) {
    //   //   this.updateHotSpotData()
    //   // }
    // },
    //h5页面播放器
    showVideoLayer(hotspotInfo) {
      this.videoActive = hotspotInfo.videourl
      this.videoLayerShow = true
      //暂停音频
      // this.isAudioPlay = false
      this.$refs.horn.pause();//暂停音频
    },
    closeVideoLayer() {
      console.log('关闭视频')
      console.log( this.isAudioPlay)
      this.videoLayerShow = false
      this.$refs.video.pause();//暂停视频
      if( this.isAudioPlay){        //如果之前是播放状态，则继续播放音频
      this.$refs.horn.play();//继续播放音频
      }
    },
    //存储热点
    updateHotSpotData() {
      var hotSpotHTML;
      var dataHotSpotList = { list: [] };
      //修改全局变量
      var hotSpotData = [];

      // 确保 krpano 对象存在
      if (!this.krpano) return;

      // 获取所有热点
      const spots = this.krpano.get("hotspot").getArray();
      if (!spots) return;

      spots.forEach((everySpot) => {
        if (everySpot.name !== "vr_cursor" &&
            everySpot.name !== 'webvr_prev_scene' &&
            everySpot.name !== 'webvr_next_scene') {

          dataHotSpotList.list.push(everySpot);
          var hotSpot = {
            ath: everySpot.ath?.toString() || "0",
            atv: everySpot.atv?.toString() || "0",
            linkedscene: everySpot.linkedscene || "",
            name: everySpot.name || "",
            style: everySpot.style || "",
            title: everySpot.title || "",
            dive: everySpot.dive || "",
            loop: everySpot.loop || false,
            url: everySpot.url || "",
            edge: everySpot.edge || "center",
            scale: everySpot.scale || 1,
            videourl: everySpot.videourl || "",
            posterurl: everySpot.posterurl || "",
            distorted: everySpot.distorted || false,
            type: everySpot.type || "",
            pausedonstart: everySpot.pausedonstart || false,
            peak_type: everySpot.peak_type || 0,
            peak_sceneId: everySpot.peak_sceneId || 0,
            peak_tooltip: everySpot.peak_tooltip || "",
            peak_to_sceneId: everySpot.peak_to_sceneid || 0,
            peak_to_scene: everySpot.peak_to_scene || "",
            οnclick: 'togglepause()'
          };

          hotSpotData.push(hotSpot);
        }
      });

      // 确保 sceneList 是有效的数组
      if (!Array.isArray(this.sceneList)) {
        this.sceneList = [];
      }

      // 获取当前场景索引
      const currentIndex = this.currentSceneId;

      // 只有当 currentIndex 有效且在 sceneList 范围内时才更新
      if (typeof currentIndex === 'number' &&
          currentIndex >= 0 &&
          currentIndex < this.sceneList.length) {

        // 保留原有场景的其他属性
        const existingScene = this.sceneList[currentIndex] || {};

        // 更新场景数据
        this.sceneList[currentIndex] = {
          ...existingScene,
          hotSpots: hotSpotData,
          audioUrl: this.audioUrl || existingScene.audioUrl
        };

        console.log('Updated scene:', this.sceneList[currentIndex]);
      } else {
        console.warn('Invalid scene index:', currentIndex);
      }
    },
    //热点选择模块
    selectHotSpot() {
      this.krpano.call("screentosphere(mouse.x, mouse.y, mouseath, mouseatv);");
      var nearHotSpot = {};
      let that = this
      this.krpano.get("hotspot").getArray().forEach(function (thisHotSpot) {
        var thisAthDis = that.krpano.get("hotspot[" + thisHotSpot.name + "]").ath - that.krpano.get("mouseath");
        var thisAtvDis = that.krpano.get("hotspot[" + thisHotSpot.name + "]").atv - that.krpano.get("mouseatv");
        var thisDis = Math.abs(thisAthDis) + Math.abs(thisAtvDis);
        if (!nearHotSpot.name) {
          nearHotSpot = { name: thisHotSpot.name, athDis: thisAthDis, atvDis: thisAtvDis, dis: thisDis };
        } else {
          if (thisDis < nearHotSpot.dis) {
            nearHotSpot = { name: thisHotSpot.name, athDis: thisAthDis, atvDis: thisAtvDis, dis: thisDis };
          }
        }
      });
      return nearHotSpot;
    },
    // //热点移动模块
    // autoMove() {
    //   this.krpano.call("screentosphere(mouse.x, mouse.y, mouseath, mouseatv);");
    //   this.krpano.set("hotspot[" + this.movingSpot.name + "].ath", this.krpano.get("mouseath") + this.movingSpot.athDis);
    //   this.krpano.set("hotspot[" + this.movingSpot.name + "].atv", this.krpano.get("mouseatv") + this.movingSpot.atvDis);
    //   this.updateHotSpotData()//更新场景数据
    // },

    /**peak_sceneId
     */
    // clickHotspot(hotspotInfo) {
    //   if (hotspotInfo.peak_type == 2) {
    //     alert("我是普通的热点");
    //   } else if (hotspotInfo.peak_type == 3) {
    //     // 跳转热点
    //     this.currentSceneId = hotspotInfo.peak_to_sceneId;
    //     this.goToScene({
    //       peak_to_scene: hotspotInfo.peak_to_scene,
    //       peak_to_sceneId: hotspotInfo.peak_to_sceneId,
    //     });
    //   }
    //   this.togglepause()
    // },
    /**
     * 获取切换场景的动画类型
     * @param {number} type  跳转的动画类型
     */
    getToggleSceneAnimation(type = 1) {
      let blend;
      switch (type) {
        case 1:
          // 从当前全景图混合/交叉淡入淡出到下一个全景图。
          blend = "BLEND(1.0, easeInCubic)";
          break;
        case 2:
          // 变焦混合
          blend = "ZOOMBLEND(2.0, 2.0, easeInOutSine)";
          break;
        case 3:
          // 打底黑
          blend = "COLORBLEND(2.0, 0x000000, easeOutSine)";
          break;
        case 4:
          // 打底白
          blend = "LIGHTBLEND(1.0, 0xFFFFFF, 2.0, linear)";
          break;
        case 5:
          // 从右到左
          blend = "SLIDEBLEND(1.0, 0.0, 0.2, linear)";
          break;
        case 6:
          // 从上到下
          blend = "SLIDEBLEND(1.0, 90.0, 0.01, linear)";
          break;
        case 7:
          // 沿对角线运动的
          blend = "SLIDEBLEND(1.0, 135.0, 0.4, linear)";
          break;
        case 8:
          // 开口圆
          blend = "OPENBLEND(1.0, 0.0, 0.2, 0.0, linear)";
          break;
        case 9:
          // 垂直性开合
          blend = "OPENBLEND(0.7, 1.0, 0.1, 0.0, linear)";
          break;
        case 10:
          // 水平性开合
          blend = "OPENBLEND(1.0, -1.0, 0.3, 0.0, linear)";
          break;
        case 11:
          // 椭圆+变焦
          blend = "OPENBLEND(1.0, -0.5, 0.3, 0.8, linear)";
          break;

        default:
          break;
      }

      return blend;
    },

    //取消背景音乐
    clearAudio() {
      this.audioUrl = ''
      this.isAudioadd = false
      this.isAudioPlay = false//任何操作都会暂停播放音乐
      if (this.$refs.horn) {
        this.$refs.horn.pause();//暂停
      }
      this.isAudioNow = 0//用来判断当前点击的是当前场景还是全局背景音乐
      // this.updateHotSpotData()
    },
    /**
     * 场景结合动画跳转
     * @param {number} obj 信息
     * @param {number} animationType  跳转的动画类型
     */
    goToScene(obj, animationType = 1, is = true) {
      let blend = this.getToggleSceneAnimation(animationType);
      this.krpano.call(`loadscene(${obj.peak_to_scene}, null, MERGE, ${blend})`);//设置当前环境为点击的热点环境
      this.currentSceneId = obj.peak_to_sceneId;
      //如果之前设置了第一视角就显示第一视角
      if (this.sceneList[this.currentSceneId] && this.sceneList[this.currentSceneId].initH) {
        //设置当前环境第一视角
        this.krpano.set("view.hlookat", this.sceneList[this.currentSceneId].initH);
        this.krpano.set("view.vlookat", this.sceneList[this.currentSceneId].initV);

      }
      this.clearAudio()
      //如果之前有视频关闭视频
      if (this.videoLayerShow) {
        this.videoLayerShow = false
        this.$refs.video.pause();//暂停视频
      }
      let scenceName = this.krpano.get("xml.scene"); // 当前场景图
      // 有很多时候当前场景图拿不到，需要重新调
      let getScenceNameTime = setInterval(() => {
        scenceName = this.krpano.get("xml.scene"); // 当前场景图

        if (scenceName) {
          if (this.krpano.get("scene").getItem(scenceName)) {
            if (this.krpano.get("scene").getItem(scenceName).remark) {
              this.currentSceneName = this.krpano.get("scene").getItem(scenceName).remark;//获取当前场景名称
              this.scenceImgId = this.krpano.get("scene").getItem(scenceName).title
              // console.log('当前场景', that.currentSceneName)
            }
          }
          // 场景加载完成以后再去加载热点
          this.getSceneHotspotNow(this.currentSceneId)
          setTimeout(() => {        // 获取场景的热点
            this.getSceneHotspot();
          }, 1000);
          clearInterval(getScenceNameTime)

        }
      }, 1000)
      // if (scenceName) {//场景加载过慢，需要缓冲重新加载
      // } else {
      // }
    },
    // goToScene(obj, animationType = 1, is = true) {
    //   if (!this.krpano || !obj) return;
    //
    //   // 预加载热点数据
    //   this.getSceneHotspotNow(obj.peak_to_sceneId);
    //
    //   // 场景切换
    //   const blend = this.getToggleSceneAnimation(animationType);
    //   this.krpano.call(`loadscene(${obj.peak_to_scene}, null, MERGE, ${blend})`);
    //   this.currentSceneId = obj.peak_to_sceneId;
    //
    //   // 延迟加载热点
    //   setTimeout(() => {
    //     this.getSceneHotspot();
    //   }, 500);
    // },

    /**
     * 处理去加载场景热点
     */
    getSceneHotspot() {
      // console.log('处理去加载场景热点',this.krpano)
      if (!this.krpano) return;
      // 添加新热点
      this.HotSpotList.forEach(item => {
         console.log(item,'item')
        this.addhotspoti(item);
      });

      this.videoList.forEach(item => {
        this.addhotspoti(item);
      });
    },
    //添加场景事件
    addPano() {
      console.log('添加场景事件')
    },
  },
};
</script>
<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.container {
  width: 100%;
  height: 100%;
  background: #1c283c;
  color: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
}

.overlay-center-pano {

  height: 100%;
  width: 100%;
  // border-radius: 5px;
  overflow: hidden;
  position: relative;
}

#pano {
  height: 100vh;
  width: 100%;
}

.overlay-view {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #363636;
  // border-radius: 5px;
  overflow: hidden;
}

.overlay-view img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}

.overlay-view-title {
  font-size: 16px;
  text-align: center;
  padding: 10px 0;
  background: #2E5CF6;
  border-radius: 4px;
  padding: 7px 20px;
  width: auto;
  height: auto;
  position: absolute;
}

.overlay-left {
  width: 60px;
  height: 100%;
  float: left;
}

.overlay-left-li {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 20%;
  margin-bottom: 30px;
  padding: 10px 0;
}

.overlay-left-li.act {
  background: #2E5CF6;
  border-radius: 4px;
}

.overlay-left-li img {
  width: 22px;
  height: auto;
  margin-bottom: 5px;
}

.overlay-right {
  width: 190px;
  height: auto;
  margin: 0 10px;
}

.overlay-right-title {
  background: #363636;
  width: 100%;
  margin-bottom: 20px;
  width: 100%;
  height: 40px;
  padding: 10px;
  border-radius: 4px;
}

.overlay-center {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.scene-select-box {
  margin-bottom: 10px;

  ul {
    display: flex;

    li {
      margin: 3px;

      img {
        width: 100px;
        height: 100px;
      }
    }
  }

  .hotspot-detail-scene-selected {
    border: solid #409eff 2px;
  }
}

.btn {
  cursor: pointer;
  display: inline-block;
  padding: 8px 20px;
  background-color: rgba(0, 0, 0, .7);
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
}

.btn-blue {
  background-color: #2185D0;
}

.scene-name {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .6);
  color: #fff;
  text-align: right;
  height: 40px;
  line-height: 40px;
  padding-right: 15px;
}

.frame-line {
  position: absolute;
  background-color: #eee;
}

.frame-line-top,
.frame-line-bottom {
  height: 1px;
  left: 30%;
  right: 30%;
}

.frame-line-top {
  top: 25%;
}

.frame-line-bottom {
  bottom: 25%;
}

.frame-line-left,
.frame-line-right {
  top: 25%;
  bottom: 25%;
  width: 1px;
}

.frame-line-left {
  left: 30%;
}

.frame-line-right {
  right: 30%;
}

.angle {
  width: 40px;
  height: 40px;
  position: absolute;
}

.angle i {
  position: absolute;
  background-color: #eee;
}

.angle-a {
  left: 0;
  width: 8px;
  top: 0;
  bottom: 0;
}

.angle-b {
  top: 0;
  left: 0;
  right: 0;
  height: 8px;
}

.angle-tl {
  left: 30%;
  top: 25%;
}

.angle-tr {
  right: 30%;
  top: 25%;
}

.angle-tr .angle-a {
  left: auto;
  right: 0;
}

.angle-bl {
  left: 30%;
  bottom: 25%;
}

.angle-bl .angle-b {
  bottom: 0;
  top: auto;
}

.angle-br {
  right: 30%;
  bottom: 25%;
}

.angle-br .angle-a {
  left: auto;
  right: 0;
}

.angle-br .angle-b {
  top: auto;
  bottom: 0;
}

.frame .btn {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0);
}

.overlay {
  position: absolute;
  right: 415px;
  top: 15px;
  z-index: 9999;
}

.save-wrap {
  margin-top: 40px;
  margin-bottom: 20px;
}

.tool-panel {
  position: relative;
}

.tool-btn-lst {
  float: right;
}

.tool-btn-lst>li {
  margin-bottom: 10px;
  position: relative;
}

.tool-main {
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: absolute;
  z-index: 9999;
  right: 150px;
  top: 100px;
  padding: 15px;
  background-color: rgba(0, 0, 0, .7);
  min-width: 200px;
  border-top: 3px solid #00a3d8;
}

.tool-section {
  border-bottom: 1px solid #2185D0;
  padding: 15px 0;
  color: #ffffff;
}

.tool-section:last-child {
  margin-bottom: 0;
  border-bottom: none;
  padding-bottom: 0;
}

.tool-section:first-child {
  padding-top: 0;
}

.tool-section .active {
  border: 1px solid #2185D0;
}

.tool-section h4 {
  color: #ffffff;
}

.tool-section li {
  display: flex;
  justify-content: space-between;
}

.tool-section .select-span {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.choose-lst {
  margin: 7px 0;
}

.choose-lst li {
  padding: 3px 0;
}

.choose-lst input {
  margin-right: 5px;
}

.left-column {
  position: absolute;
  top: 0;
  left: -250px;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.3);
  width: 250px;
  height: 100%;
  -webkit-animation: hideLeft 0.8s infinite;
  -webkit-animation-iteration-count: 1;
}

@-webkit-keyframes showLeft {
  0% {
    left: -250px;
  }

  100% {
    left: 0;
  }
}

@-webkit-keyframes hideLeft {
  0% {
    left: 0;
  }

  100% {
    left: -250px;
  }
}

.scene-select {
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  padding-bottom: 1px;
  overflow: auto;
  max-height: 600px;
  overflow-x: hidden;
}

.blue-banner {
  background-color: #00a3d8;
  height: 3px;
}

.li-scene {
  list-style-type: none;
  height: 30px;
  border: 2px solid rgba(255, 255, 255, 0);
  margin: 10px;
  width: 200px;
}

.li-scene:hover {
  border-color: #FF9800;
}

.li-scene-hover {
  border-color: #FF9800;
}

.li-scene-span {
  cursor: pointer;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  float: left;
  width: 100px;
  overflow: hidden;
}

.li-scene-input {
  background-color: rgba(185, 185, 185, 0.5);
  height: 30px;
  width: 100px;
  font-size: 18px;
}

.scene-li-button {
  width: 30px;
  height: 30px;
  // background: rgba(255, 255, 255, 0) url("../img/krpano.modify.png");
  border: 0;
  float: right;
  cursor: pointer;
}

.circle {
  width: 30px;
  height: 30px;
  float: right;
  // background: #292827 url("../img/krpano.home.png");
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}

.select_scene_text {
  text-align: center;
  background-color: rgba(40, 40, 40, 0.7);
  height: 50px;
}

.p_title {
  margin-top: 0;
  font-size: 20px;
  line-height: 50px;
}

.add-hot-pot {
  position: absolute;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.8);
  width: 700px;
  height: 440px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.progress-banner {
  margin: 20px;
  background-color: rgba(150, 150, 150, 0.4);
  height: 30px;
}

.progress-title {
  float: left;
  text-align: center;
  width: 33.33%;
  height: 100%;
}

.progress-title-on {
  background-color: #00a3d8;
}

.add-hot-banner {
  font-size: 16px;
  background-color: rgba(150, 150, 150, 0.4);
  padding: 8px 8px 8px 15px;
  height: 20px;
  line-height: 20px;
}

.div-close {
  cursor: pointer;
  float: right;
  font-size: 30px;
}

.add-hot-content {
  margin: 10px 20px 20px 20px;
}

.add-hot-bottom-div {
  height: 250px;
}

.write-title {
  font-size: 18px;
  text-align: center;
}

#addHotTitle {
  color: white;
  width: 57%;
  background-color: rgba(150, 150, 150, 0.4);
}

.add-hot-button {
  cursor: pointer;
  background-color: #00a3d8;
  line-height: 30px;
  text-align: center;
  font-size: 18px;
  height: 30px;
}

.hot-style {
  background-color: rgba(255, 255, 255, 0);
  border: 2px solid rgba(255, 255, 255, 0);
  cursor: pointer;
  margin: 7px;
  width: 64px;
  height: 56px;
  background-size: cover;
  float: left;
}

.hot-spot-img {
  background-color: rgba(255, 255, 255, 0);
  width: 32px;
  height: 32px;
  background-size: cover;
  float: left;
}

.hot-style:hover {
  border: 2px solid orange;
}

.hot-style-on {
  border: 2px solid orange;
}

.select-scene-div {
  float: left;
  width: 80px;
  text-align: center;
  cursor: pointer;
  margin: 5px;
}

.select-scene-div:hover {
  margin: 3px;
  border: 2px solid orange;
}

.select-scene-div-on {
  margin: 3px;
  border: 2px solid orange;
}

.thumbs-img {
  height: 80px;
  background-size: 80px 80px;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.thumbs-img-scene-list {
  width: 30px;
  height: 30px;
  background-size: 30px 30px;
  float: left;
  margin-right: 10px;
}

.hot-pot-select-span {
  position: absolute;
  left: 15px;
  top: 5px;
}

.wait-time-input {
  vertical-align: middle;
  width: 30px;
  background-color: rgba(255, 255, 255, 0.5);
  text-align: center
}

.fov-input {
  vertical-align: middle;
  width: 65px;
  background-color: rgba(255, 255, 255, 0.5);
  text-align: center;
  float: right;
  height: 21px;
}

.hot-spot-list {
  height: 32px;
  width: 200px;
  color: white;
  font-size: 18px;
  border: solid 2px rgba(0, 0, 0, 0);
  margin-top: 5px;
}

.hot-spot-text {
  width: 130px;
  height: 26px;
  float: left;
  text-align: center;
  padding: 3px;
}

.hot-spot-del {
  cursor: pointer;
  width: 32px;
  height: 32px;
  float: left;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.1);
}

.hot-spot-button {
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1);
  height: 32px;
  width: 202px;
  color: white;
  font-size: 18px;
  margin-top: 10px;
}

.hot-spot-list-hover {
  border: solid 2px orange;
}

.number-pb {
  position: relative;
  height: 3px;
  background-color: #ffffff;
  margin: 40px 0;
}

.number-pb .number-pb-shown {
  position: absolute;
  background: #00a3d8;
  left: 0;
  height: 3px;
}

.number-pb .number-pb-num {
  position: absolute;
  background-color: #00a3d8;
  left: 0;
  padding: 0 5px;
}

.triangle-up-left {
  border-bottom: 20px solid #00a3d8;
  margin-top: 3px;
  margin-left: -10px;
}

.triangle-up-right {
  border-bottom: 20px solid #00a3d8;
  margin-top: 3px;
  margin-right: -10px;
}

.triangle-down {
  border-top: 20px solid #00a3d8;
  margin-top: -20px;
  float: none;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}

.my-open-out {
  margin-left: 90px;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  position: relative;
  background: #00a3d8;
}

.my-open-in {
  width: 18px;
  height: 18px;
  border-radius: 9px;
  position: absolute;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  top: 1px;
}

.my-open-in-open {
  right: 1px;
}

.my-open-in-close {
  left: 1px;
}

.dive-text {
  line-height: 20px;
  float: left;
  margin-left: 20px;
}

.action {
  position: fixed;
  z-index: 999;
  left: 0;
  bottom: 0;
}


.frame {
  position: fixed;
  z-index: 9999;
  width: 80%;
  height: 600px;
}

.frame-line {
  position: absolute;
  background-color: #eee;
}

.frame-line-top,
.frame-line-bottom {
  height: 1px;
  left: 30%;
  right: 30%;
}

.frame-line-top {
  top: 25%;
}

.frame-line-bottom {
  bottom: 25%;
}

.frame-line-left,
.frame-line-right {
  top: 25%;
  bottom: 25%;
  width: 1px;
}

.frame-line-left {
  left: 30%;
}

.frame-line-right {
  right: 30%;
}

.frame .btn {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0);
}

.tool_header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tool_header img {
  width: auto;
  height: 14px;
  margin-right: 10px;
}

.tool_header_left {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #363636;
  padding: 5px 10px;
  margin: 10px;
  border-radius: 4px;
}

.tool_header_left.act {
  background-color: #2E5CF6;
}

.tool_main {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.tool-right-section {
  width: 100%;
  height: auto;
  background: #363636;
  padding: 10px;
  border-radius: 4px;
}

.tool-right-section-content {
  width: 100%;
  height: 60px;
  margin-top: 10px;
  position: relative;
}

.tool-right-section-content-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}

#panoMini {
  width: 100%;
  height: 60px;
}

.tool-right-section-ul {
  width: 100%;
  height: auto;
  max-height: 75vh;
  overflow: auto;
}

.tool-right-section-ul li {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #363636;
  border-radius: 4px;
  padding: 0 4px;
}

.tool-right-section-ul li .section-img {
  width: 24px;
  height: 20px;
  margin-right: 3px;
}

.tool-right-section-ul li .section-span1 {
  width: auto;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.tool-right-section-ul li .section-span {
  width: 10px;
  height: 10px;
}

.tool-right-but {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #2E5CF6;
  margin-top: 10px;
  border-radius: 4px;
}

.tool-right-but1 {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #4D4D4D;
  margin-top: 10px;
  border-radius: 4px;
}


.mssage {
  position: fixed;
  top: -200px;
  left: 50%;
  width: 200px;
  height: auto;
  margin-left: -100px;
  padding: 10px;
  border-radius: 5px;
  background: #4D4D4D;
  z-index: 9999;
  text-align: center;
}

.mssage.act {
  opacity: 1;
  top: 100px;
  animation: myfirst 3s;
  -webkit-animation: myfirst 3s;
  /* Safari and Chrome */
}

@keyframes myfirst {
  0% {
    top: -200px;
  }

  25% {
    top: 100px;
  }

  50% {
    top: 100px;
  }

  75% {
    top: 100px;
  }

  100% {
    top: -200px;
  }
}

@-webkit-keyframes myfirst

/* Safari 与 Chrome */
  {
  0% {
    top: -200px;
  }

  25% {
    top: 100px;
  }

  50% {
    top: 100px;
  }

  75% {
    top: 100px;
  }

  100% {
    top: -200px;
  }
}

.audioact {
  border: 2px solid #2E5CF6 !important;
}

.panoAudio {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 30px;
  left: 10px;
  z-index: 9999;
  background: #36363680;
  padding: 6px;
  border-radius: 4px;
}

.panoAudio1 {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 70px;
  left: 10px;
  z-index: 9999;
  background: #36363680;
  padding: 4px;
  border-radius: 4px;
}

.panoAudio2 {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 110px;
  left: 10px;
  z-index: 9999;
  background: #36363680;
  padding: 4px;
  border-radius: 4px;
}

.overlay-video {
  width: 100%;
  height: 100%;
}

.overlay-but {
  position: absolute;
  top: 7px;
  right: 7px;
  z-index: 9999999;
  width: 15px;
  height: 15px;
}

.overlay-but img {

  width: 15px;
  height: 15px;
}

.edit_container {
  width: 100%;
  height: 100%;
  background: #ffffff;
  position: absolute;
  z-index: 999999;
  top: 0%;
  left: 0%;
  //padding: 10px;
  border-radius: 10px;
  color: #000000;
  overflow: hidden;
}

.edit_close {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 13px;
  background: #fff;
  border-radius: 18px;
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
}

.edit_close img {
  width: 10px;
  height: 10px;
}

.quill-but {
  position: absolute;
  bottom: 17px;
  left: 50%;
  width: 200px;
  margin-left: -100px;
}

.quill-main {
  width: 100%;
  height: 100%;
  overflow: auto;
  border-radius: 10px;
}
</style>
